import { useState, useEffect } from "react";
import { useTelegram } from "./useTelegram";

type Language = "en" | "ru" | "uk";

interface Translations {
  [key: string]: any;
}

// const translations: Record<Language, Translations> = {
// en: {},
// ru: {},
// uk: {},
// };

const loadTranslations = async (lang: Language): Promise<Translations> => {
  try {
    const module = await import(`../locales/${lang}.json`);
    return module.default;
  } catch (error) {
    console.warn(`Failed to load translations for ${lang}, falling back to English`);
    const module = await import(`../locales/en.json`);
    return module.default;
  }
};

export const useTranslation = () => {
  const { user } = useTelegram();
  const [currentLang, setCurrentLang] = useState<Language>("en");
  const [translations, setTranslations] = useState<Translations>({});

  useEffect(() => {
    const initializeLanguage = async () => {
      let lang: Language = "en";

      if (user?.language_code) {
        const tgLang = user.language_code.toLowerCase();
        if (tgLang.startsWith("ru")) {
          lang = "ru";
        } else if (tgLang.startsWith("uk")) {
          lang = "uk";
        } else {
          lang = "en";
        }
      }

      setCurrentLang(lang);
      const loadedTranslations = await loadTranslations(lang);
      setTranslations(loadedTranslations);
    };

    initializeLanguage();
  }, [user?.language_code]);

  const t = (key: string, params?: Record<string, string | number>): string => {
    const keys = key.split(".");
    let value: any = translations;

    for (const k of keys) {
      if (value && typeof value === "object" && k in value) {
        value = value[k];
      } else {
        console.warn(`Translation key "${key}" not found for language "${currentLang}"`);
        return key;
      }
    }

    if (typeof value !== "string") {
      console.warn(`Translation value for key "${key}" is not a string`);
      return key;
    }

    // Заменяем параметры в строке
    if (params) {
      return value.replace(/\{\{(\w+)\}\}/g, (match, paramKey) => {
        return params[paramKey]?.toString() || match;
      });
    }

    return value;
  };

  return {
    t,
    currentLang,
  };
};
